import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { DataService } from './services/dataService.service';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './menu/menu.component';
import { StartComponent } from './start/start.component';
import { NewswidgetComponent } from './newswidget/newswidget.component';
import { CaseComponent } from './case/case.component';
import { ContentComponent } from './content/content.component';
import { ImageComponent } from './image/image.component';
import { QuoteComponent } from './quote/quote.component';
import { DownarrowComponent } from './downarrow/downarrow.component';
import { CasewidgetComponent } from './casewidget/casewidget.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { CustomersComponent } from './customers/customers.component';
import { NewslistComponent } from './newslist/newslist.component';
import { NewspostComponent } from './newspost/newspost.component';
import { VideoComponent } from './video/video.component';
import { StudiosComponent } from './studios/studios.component';
import { MasonrygridComponent } from './masonrygrid/masonrygrid.component';
import { ErrorComponent } from './error/error.component';

@NgModule({
  declarations: [
      SafeHtmlPipe,
      AppComponent,
      HeaderComponent,
      FooterComponent,
      MenuComponent,
      StartComponent,
      NewswidgetComponent,
      NewslistComponent,
      NewspostComponent,
      CaseComponent,
      ContentComponent,
      ImageComponent,
      VideoComponent,
      QuoteComponent,
      DownarrowComponent,
      CasewidgetComponent,
      AboutComponent,
      ContactComponent,
      CustomersComponent,
      StudiosComponent,
      MasonrygridComponent,
      ErrorComponent
  ],
  imports: [
      AppRoutingModule,
      BrowserModule.withServerTransition({ appId: 'bloomyuniversal' }),
      HttpClientModule,
      BrowserAnimationsModule,
  ],
  providers: [DataService, RouterModule],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/app.module.ts